import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const ConfirmationDialog = ({ open, onConfirm }) => {

	return (
		<Dialog
			open={open}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			
		>
			<DialogTitle id='alert-dialog-title'>{'Success!'}</DialogTitle>
			<DialogContent >

				<Typography align='center'><CheckCircleIcon size='large' style={{color:'green',fontSize: 80}} /></Typography>
				<Typography align='center' paragraph>Your response has been successfully recorded.</Typography>
				<Typography align='center' >To exit, close your browser.</Typography>
				<Typography align='center' >Thank You!</Typography>

			</DialogContent>
			<DialogActions>
				<Button onClick={onConfirm} color='primary' autoFocus>
					Fill out form again.
				</Button>
			</DialogActions>
		</Dialog>
	);

};

ConfirmationDialog.propTypes = {
	open: PropTypes.bool,
	onConfirm: PropTypes.func
};
export default ConfirmationDialog;



